module.exports = __webpack_public_path__ + "static/media/gu-integral-mall.f0e1fdbd.jpeg";